export default "__VITE_ASSET__CPDK0IDM__"